import { render, staticRenderFns } from "./KeywordsBulk.vue?vue&type=template&id=af199380&scoped=true&"
import script from "./KeywordsBulk.vue?vue&type=script&lang=js&"
export * from "./KeywordsBulk.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsBulk.vue?vue&type=style&index=0&id=af199380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af199380",
  null
  
)

/* custom blocks */
import block0 from "./KeywordsBulk.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports